import React, {useState, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Button, Typography} from '@mui/material';
import {StyledBodyCell} from '../components';

const buttonStyles = {
  mt: 0,
  mb: 1,
  mx: 1,
  padding: '4px !important',
  color: '#26A993',
  fontSize: 12,
  fontWeight: 500,
};

export function SignedAccountsCell({signedAccounts}) {
  const [showAll, setShowAll] = useState(false);

  const visibleAccounts = useMemo(() => {
    if (showAll) {
      return signedAccounts.map((v) => <Typography key={v}>{v}</Typography>);
    }
    return signedAccounts
      .slice(0, 3)
      .map((v) => <Typography key={v}>{v}</Typography>);
  }, [showAll]);

  return (
    <StyledBodyCell>
      <div>{visibleAccounts}</div>
      {signedAccounts.length > 3 && (
        <Button
          sx={buttonStyles}
          onClick={() => {
            setShowAll(!showAll);
          }}
        >
          {showAll ? 'View Less' : `View All (${signedAccounts.length})`}
        </Button>
      )}
    </StyledBodyCell>
  );
}

SignedAccountsCell.propTypes = {
  signedAccounts: PropTypes.array.isRequired,
};
